/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Discord_Bot_DescriptionInputs */



/**
* | output |
* | --- |
* | "Add the OpenRift bot to your Discord server to look up cards, unfurl deck codes, and quote rules right from chat." |
*
* @param {Help_Article_Discord_Bot_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_discord_bot_description = /** @type {((inputs?: Help_Article_Discord_Bot_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Discord_Bot_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Füge den OpenRift-Bot zu deinem Discord-Server hinzu, um Karten nachzuschlagen, Deck-Codes aufzuklappen und Regeln direkt im Chat zu zitieren.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajoutez le bot OpenRift à votre serveur Discord pour rechercher des cartes, déplier des codes de deck et citer des règles directement dans le chat.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("把 OpenRift 机器人加入你的 Discord 服务器，直接在聊天里查卡、展开卡组代码并引用规则。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("把 OpenRift 機器人加進你的 Discord 伺服器，直接在聊天室查卡、展開牌組代碼與引用規則。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("Discord 서버에 OpenRift 봇을 추가해 채팅에서 바로 카드를 찾고, 덱 코드를 펼쳐 보고, 규칙을 인용하세요.")
	return /** @type {LocalizedString} */ ("Add the OpenRift bot to your Discord server to look up cards, unfurl deck codes, and quote rules right from chat.")
});